import { DELETE, INSERT, SELECT, UPDATE } from "@/utils/database_module"
import { logDebug } from "@/utils/helpers"
import { Product } from "@/utils/types"

const favorites = {
    getAll : async (isFavoritesPage : boolean , user_id : number) => {
        let favorites = await SELECT("favorites" , { conditions : [{column : "user_id" , operator : "=" , value : user_id}] , order : "date DESC"}) as( Product & {product_id : number , user_id : number})[]
        if (!isFavoritesPage) return favorites
        
        const products = await SELECT("products" , {}) as Product[]
  

        for (let i = 0; i < favorites.length; i++) {
            const product = products.find((p) => p.id == favorites[i].product_id)

            const images =product && typeof product.images =='string' ? JSON.parse(`${product.images}`) : product?.images;
            favorites[i] = { ...product, ...favorites[i] ,  images: images };
          }
        return favorites
    },



    insert : async (data : {product_id : number , user_id : number}) => {
        const { product_id , user_id } = data
        const favorites = await SELECT("favorites" , { conditions : [{column : "product_id" , operator : "=" , value : product_id} , {column : "user_id" , operator : "=" , value : user_id}] , })
       
        if (favorites.length == 0)  return await INSERT("favorites" , data)
        if (favorites.length != 0) 
            return await DELETE("favorites", [ { column: "product_id", operator: "=", value: product_id, }, { column: "user_id", operator: "=", value: user_id, }, ]);
              
        
    },

    isProductFavorite : async (product_id : number , user_id : number) => {
        const favorites = await SELECT("favorites" , { conditions : [{column : "product_id" , operator : "=" , value : product_id} , {column : "user_id" , operator : "=" , value : user_id}] , }) as unknown as {product_id : number , user_id : number}[]
        return favorites.length != 0 
    },

}

export default favorites